
export default {
  name: "SingleBlock",
};
